<template>
  <!-- 添加dom记得适应手机端 -->
  <div class="mapcontainer">
    <div class="infoview">
      <input
        id="btnStop"
        @click="flyToPile"
        type="button"
        class="btn btn-primary"
        value="flyTo"
      />
      <input
        @click="zou"
        type="button"
        class="btn btn-primary"
        value="当前人数：4人"
      />
    </div>
    <Map :url="configUrl" @onload="onMapload" />

    <div v-if="searchResult && !showTilte" class="searchResultClass">
      <div >
        <el-table
          :data="userList"
          border
          height="280"
          style="width: 100%; background-color: rgba(0, 0, 0, 0)"
        >
          <el-table-column prop="c_name" label="姓名" width="150"> </el-table-column>
          <el-table-column label="查看" width="250">
            <template slot-scope="scope" >
              <el-button type="primary" size="small" @click="gosee(scope.row)"
                >定位</el-button
              >
              <el-button type="primary" size="small" @click="zou(scope.row)"
                >轨迹(等待五秒)</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-if="searchResult && !showTilte" class="searchResultClass2">
      <div>
        <el-table
          :data="carList"
          border
          height="280"
          style="width: 100%; background-color: rgba(0, 0, 0, 0)"
        >
          <el-table-column prop="c_name" label="车牌号" width="100">
          </el-table-column>
          <el-table-column prop="c_type" label="类型" width="100">
          </el-table-column>
          <el-table-column label="查看" width="170">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="gosee(scope.row)"
                >定位</el-button
              >
              <el-button type="primary" size="small" @click="zou(scope.row)"
                >轨迹</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      v-if="showTilte"
      style="
        text-align: center;
        font-size: 100px;
        color: white;
        position: absolute;
        z-index: 999;
        top: 40%;
        width: 100%;
      "
    >
      人员实时智能定位系统
    </div>
  </div>
</template>

<script>
import Map from "../components/mars3d/Map.vue";

export default {
  components: {
    Map,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    const scale = 1;
    return {
      showTilte: true,
      userList: [
        // {
        //   c_name: "徐星星",
        //   c_id: "cxx",
        //   lat: 29.62442,
        //   lng: 102.165217,
        //   alt: 991.4,
        // },
        // {
        //   c_name: "刘慧",
        //   c_id: "lh",
        //   lat: 29.625155,
        //   lng: 102.164965,
        //   alt: 998.4,
        // },
        // {
        //   c_name: "赤曲",
        //   c_id: "cq",
        //   lat: 29.624565,
        //   lng: 102.165738,
        //   alt: 1011.1,
        // },
        // {
        //   c_name: "拉巴卓玛",
        //   c_id: "lbzm",
        //   lat: 29.66236,
        //   lng: 102.200262,
        //   alt: 1040.1,
        // },
      ],
      carList: [
        // { c_name: "川A12345", c_type: "土方", c_id: "cxx",
        //   lat: 29.625552,
        //   lng: 102.164812,
        //   alt: 1002.3 },
        // { c_name: "川A12345", c_type: "运输", c_id: "lh",
        //   lat: 29.625234,
        //   lng: 102.165569,
        //   alt: 1011.7 },
        // {
        //   c_name: "川A12345",
        //   c_type: "挖掘机",
        //   c_id: "cq",
        //   lat: 29.6625,
        //   lng: 102.20021,
        //   alt: 1040.6
        // }
      ],
      searchResult: true,

      configUrl: basePathUrl + "static/mapconfig/config.json", // 配置文件
     // askurl: "http://mcc.wedam.com.cn/zhenchongearth",
      askurl: "",
      map: {},
      timeStep: 10,
      graphicLayer: {},
      data: [],

      needtime: 10, //快放多少倍
    };
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.showTilte = false;
      document.getElementsByClassName("mapcontainer")[0].style =
        "height:" + window.screen.height + "px;";
    }
    // let url =  `${this.websiteUrl}/lkApi/timeline?pileCode=${pileCode}&count=${this.count}`
    mars3d.Resource.fetchJson({
      url: "http://122.152.198.146:6404/app/getNowPlace?rack_id=1012001",
    })
      .then((res) => {
        if (res != null) {
          mars3d.Resource.fetchJson({
            url:
              "http://122.152.198.146:6171/getonepoint?lat=" +
              res.data.lat +
              "&lng=" +
              res.data.lng,
          })
            .then((res2) => {
              this.userList.push({
                c_name: "徐星星",
                c_id: "xxx",
                lat: res2.data.lat,
                lng: res2.data.lng,
                alt: res2.data.alt,
                rack: "1012001",
              });
            })
            .otherwise(() => {
              globalMsg("实时查询定位信息失败");
            });
        }
      })
      .otherwise(() => {
        globalMsg("实时查询定位信息失败");
      });
  },
  methods: {
    xiuzhen() {
      let data = this.data.data;

      let firsttime = data[0].time;
      if (data.length < 60) {
        for (let index = 0; index < data.length; index++) {
          data[index].time = firsttime + index * 1000;
        }
      } else {
        for (let index = 0; index < data.length; index++) {
          data[index].time =
            firsttime + parseInt((data[index].time - firsttime) / 80);
        }
      }
      this.data = data;
    },
    gosee(item) {
      const { map } = this;

      map.flyToPoint({
        lat: item.lat,
        lng: item.lng,
        alt: item.alt,
        heading: 4,
        pitch: -43,
      });
    },
    zou(item) {
      var that = this;
      const { map, mars3d } = this;
      console.log("http://122.152.198.146:6171/getpoints?start=" +
          parseInt(Date.now() / 1000 - 8 * 60 * 60) +
          "&end=" +
          parseInt(Date.now() / 1000) +
          "&rack=" +
          item.rack)
      mars3d.Resource.fetchJson({
        url:
          "http://122.152.198.146:6171/getpoints?start=" +
          parseInt(Date.now() / 1000 - 8 * 60 * 60) +
          "&end=" +
          parseInt(Date.now() / 1000) +
          "&rack=" +
          item.rack,
      })
        .then((res2) => {
          that.data = res2;

          that.xiuzhen();
          map.clock.currentTime = Cesium.JulianDate.fromDate(
            new Date(this.data[0].time)
          );

          this.graphicLayer = new mars3d.layer.GraphicLayer({
            chinaCRS: "GCJ02",
          });
          map.addLayer(this.graphicLayer);
          const { graphicLayer } = this;
          graphicLayer.bindTooltip(function (event) {
            const data = event.graphic.options;
            return data.name;
          });

          map.on(mars3d.EventType.clickMap, function (event) {
            if (lastClickCar) {
              lastClickCar.removeShading("circle");
              lastClickCar = null;
            }
          });

          graphicLayer.on(mars3d.EventType.click, (event, position) => {
            const car = event.graphic;

            if (lastClickCar) {
              if (lastClickCar === car) {
                return;
              } // 重复单击，跳出
              lastClickCar.removeShading("circle");
              lastClickCar = null;
            }

            car.addShading({
              type: "circle",
              materialType: mars3d.MaterialType.CircleWave,
              speed: 10,
              count: 3,
              gradient: 0.1,
              radius: 50,
              color: "#ffff00",
              opacity: 0.3,
              show: true,
            });
            lastClickCar = car;

            // 视角定位下
            car.flyToPoint({ radius: 1000 });
          });

          let lastClickCar;
          let arr = [{ id: 1012001, name: "测试" }];
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];

            item.show = true;

            let modelParam = {
              scale: 1,
              url: "//data.mars3d.cn/gltf/mars/car/tufangche.glb",
            };

            const car = new mars3d.graphic.DynamicRoamLine({
              id: item.id,
              name: item.name,
              model: {
                clampToGround: false,
                show: true,
                ...modelParam,
              },
              shadow: [
                {
                  type: "polyline",
                  color: "rgb(40, 40, 255)",
                  width: 2,
                  clampToGround: false,
                  maxDistance: 1500,
                  show: true,
                },
              ],
            });
            graphicLayer.addGraphic(car);
          }

          // 定时获取卡车和铲车的列表数据
          this.createPath();
        })
        .otherwise(() => {
          globalMsg("实时查询定位信息失败");
        });
    },
    // 首次获取并创建轨迹
    createPath() {
      const { map, mars3d } = this;
      // 取数据的时间范围，结束时间
      const date = Cesium.JulianDate.toDate(map.clock.currentTime);
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");

      // 修改当前时间回退一分钟，因为数据永远是当前时间之前的。
      date.setSeconds(date.getSeconds());
      map.clock.currentTime = window.Cesium.JulianDate.fromDate(date);

      // 取数据的时间范围，开始时间
      date.setMinutes(date.getMinutes()); // 初次取一定时间内的数据
      const beginTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");

      // 记录最后一次读取数据的时间
      this.lastTime = endTime;

      // 取数据
      this.getPathList(beginTime, endTime);
      // 定时更新
      // setInterval(() => {
      this.updatePath();
      // }, this.timeStep * 1000);
    },
    // 后续更新轨迹
    updatePath() {
      const beginTime = this.lastTime;
      const date = new Date(beginTime);
      date.setSeconds(date.getSeconds() + this.timeStep * 60);
      // date.setMinutes(date.getMinutes() + this.timeStep)
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");
      this.lastTime = endTime;
      this.getPathList(beginTime, endTime);
    },
    // 读取车辆gps坐标路径的接口
    getPathList(beginTime, endTime) {
      const { data, graphicLayer, mars3d } = this;
      const d_beginTime = new Date(beginTime);
      const d_endTime = new Date(endTime);
      // console.log(d_beginTime);
      // console.log(d_endTime);
      // const list = data.filter((item) => {
      //   const thistime = new Date(item.time);
      //   return thistime >= d_beginTime && thistime <= d_endTime;
      // });
      const list = data;
      // 循环车辆
      graphicLayer.eachGraphic((car) => {
        // 取出对应车辆的轨迹列表
        // const path = list.filter((item) => {
        //   return item.id === car.id
        // })
        const path = list;
        if (path && path.length > 0) {
          const p = path.map((e) => {
            const time = mars3d.Util.formatDate(
              new Date(e.time),
              "yyyy-MM-dd HH:mm:ss"
            );
            return {
              time: time,
              lng: e.lng,
              lat: e.lat,
              alt: e.alt,
            };
          });
          // 更新车辆的轨迹
          car.updatePath(p, {
            timeColumn: "time",
            getPosition: function (item) {
              return Cesium.Cartesian3.fromDegrees(
                parseFloat(item.lng),
                parseFloat(item.lat),
                parseFloat(item.alt)
              );
            },
          });
        }
      });
    },
    // 地图构造完成回调
    onMapload(map) {
      this.map = map;
      this.startRotate()
      // this.initTerrainClip()
      // this.initPileGraphicLayer()
    },
    // 跳转到桩
    flyToPile() {
      this.showTilte = false;
      const { map } = this;
      this.stopRotate();

      map.setCameraView({
        lat: 29.63121,
        lng: 102.206742,
        alt: 4000,
        heading: 4,
        pitch: -43,
      });

      let tiles3dLayer = new mars3d.layer.TilesetLayer({
        type: "3dtiles",
        name: "航拍",
        //url: "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/aa/tileset.json",
        // url: "/static/place/tileset.json",mapconfig\suidao
        url: this.askurl + "/static/place/tileset.json",
        scale: 180,
        position: { lat: 29.683268, lng: 102.192033, alt: 1200 },
        // maximumScreenSpaceError: 100,
        maximumMemoryUsage: 8096,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        skipLevelOfDetail: true,
        preferLeaves: true,
        rotation: { z: -75 },
        // highlight: {
        //   type: mars3d.EventType.click, //默认为鼠标移入高亮，也可以指定click单击高亮
        //   color: "#00FF00",
        // },
        // popup: "all",
        // show: true,
        //center: { lat: 28.439577, lng: 102.2149, alt: 229, heading: 1000, pitch: -29 },
        // flyTo: true,
      });
      map.addLayer(tiles3dLayer);

      //加载的事件 只执行一次
      tiles3dLayer.on(mars3d.EventType.initialTilesLoaded, function (event) {
        console.log("触发initialTilesLoaded事件", event);
      });

      //会执行多次，重新加载一次完成后都会回调
      tiles3dLayer.on(mars3d.EventType.allTilesLoaded, function (event) {
        console.log("触发allTilesLoaded事件", event);
      });

      tiles3dLayer.on(mars3d.EventType.click, function (event) {
        var cartesian = event.cartesian;
        var point = mars3d.LatLngPoint.fromCartesian(cartesian);
        point.format(); //经度、纬度、高度

        let currJD = point.lng;
        let currWD = point.lat;
        let currGD = point.alt;
        console.log(currJD);
        console.log(currWD);
        console.log(currGD);
      });

      //河流开始
      let graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);
      let dynamicRiver = new mars3d.graphic.DynamicRiver({
        positions: [
          [102.206329, 29.748503, 1000.7],
          [102.202211, 29.747476, 1023.1],
          [102.201496, 29.742764, 1061.1],
          [102.202896, 29.739842, 1008.1],
          [102.199734, 29.734872, 1046.5],
          [102.201695, 29.722422, 1064.1],
          [102.198866, 29.716327, 1067.4],
          [102.197844, 29.705825, 1008.6],
          [102.19954, 29.699813, 1026.6],
          [102.203608, 29.692608, 1035.6],
          [102.202838, 29.690673, 994.1],
          [102.199614, 29.69046, 1016.4],
          [102.195673, 29.686864, 1002.4],
          [102.193636, 29.681253, 1023.8],
          [102.195774, 29.669946, 1030],
          [102.197781, 29.664375, 1039.5],
          [102.199693, 29.661621, 1020.7],
          [102.194549, 29.655363, 1011.7],
          [102.188603, 29.653899, 1008.6],
          [102.182402, 29.647133, 1011.2],
          [102.174555, 29.64019, 970.9],
          [102.16974, 29.636681, 985.5],
          [102.162852, 29.630806, 1016.7],
          [102.162409, 29.62735, 977.9],
          [102.165519, 29.62093, 960.1],
        ],
        style: {
          image: this.askurl + "/static/movingRiver.png",
          width: 120,
          height: 20,
          speed: 3,
        },
      });
      graphicLayer.addGraphic(dynamicRiver);

      //人员测试定位数据
      let graphicLayerw = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayerw);

      for (let ren = 0; ren < this.userList.length; ren++) {
        let userposition = [
          this.userList[ren].lng,
          this.userList[ren].lat,
          this.userList[ren].alt,
        ];
        const pilingGraphic2 = new mars3d.graphic.ModelPrimitive({
          position: userposition,
          name: this.userList[ren].c_name,
          style: {
            url: this.askurl + "/static/gongren.glb",
            spacing: 1,
            scale: 2,
            // clampToGround:true,
            heading: 90,

            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 0,
            distanceDisplayCondition_far: 1000,
            distanceDisplayBillboard: {
              // 当视角距离超过一定距离(distanceDisplayCondition_far定义的) 后显示为图标对象的样式
              image: this.askurl + "/static/helmet.png",
              scale: 1,
            },
          },
        });

        graphicLayerw.addGraphic(pilingGraphic2);
      }
      graphicLayerw.bindPopup(function (event) {
        const attr = {};
        attr["来源"] = event.graphic.options.name;

        return mars3d.Util.getTemplateHtml({
          title: "人员信息",
          template: "all",
          attr: attr,
        });
      });

      //车辆定位数据
      let graphicLayerc = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayerc);

      for (let ren = 0; ren < this.carList.length; ren++) {
        let userposition = [
          this.carList[ren].lng,
          this.carList[ren].lat,
          this.carList[ren].alt,
        ];
        const pilingGraphic2 = new mars3d.graphic.ModelPrimitive({
          position: userposition,
          name: this.carList[ren].c_name,
          type: this.carList[ren].c_type,
          style: {
            url: this.askurl + "/static/tufangche.glb",
            spacing: 1,
            scale: 1,
            // clampToGround:true,
            heading: 90,

            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 0,
            distanceDisplayCondition_far: 1000,
            distanceDisplayBillboard: {
              // 当视角距离超过一定距离(distanceDisplayCondition_far定义的) 后显示为图标对象的样式
              image: this.askurl + "/static/car.png",
              scale: 1,
            },
          },
        });

        graphicLayerc.addGraphic(pilingGraphic2);
      }
      graphicLayerc.bindPopup(function (event) {
        const attr = {};
        attr["车牌号"] = event.graphic.options.name;
        attr["类型"] = event.graphic.options.c_type;
        return mars3d.Util.getTemplateHtml({
          title: "车辆信息",
          template: "all",
          attr: attr,
        });
      });
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this;
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 });
      }
      this.stopRotate();

      this.previousTime = map.clock.currentTime.secondsOfDay;
      map.on(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    stopRotate() {
      const { map, mars3d } = this;
      map.off(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    map_onClockTick(clock) {
      const { map } = this;
      let spinRate = 150;
      let currentTime = map.clock.currentTime.secondsOfDay;
      let delta = (currentTime - this.previousTime) / 1000;
      this.previousTime = currentTime;
      map.scene.camera.rotateRight(-spinRate * delta);
    },
  },
};
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
.right-charts {
  z-index: 800;
  position: absolute;
  right: 22rem;
  top: 10px;
  font-size: 0.9rem;
  border: none;
  color: #ffffff;
  background: none;
}
.left-charts {
  z-index: 800;
  position: absolute;
  left: 0px;
  top: 9rem;
  font-size: 0.8rem;
  border: none;
  color: #ffffff;
  background: none;
}
.searchResultClass {
  position: absolute;
  z-index: 999;
  top: 70px;
  right: 100px;
  background: none;
  width: 400px;
  height: 300px;
  padding: 10px;
  /* margin-left: 20px; */
  /* margin-bottom: 20px; */
  border: 1px solid #17366c;
  background: linear-gradient(to left, #3897cf, #3897cf) left top no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) left top no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right top no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) right top no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) left bottom no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) left bottom no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  background-color: rgba(14, 8, 97, 0.418);
}
.searchResultClass2 {
  position: absolute;
  z-index: 999;
  bottom: 70px;
  right: 100px;
  background: none;
  width: 400px;
  height: 300px;
  padding: 10px;
  /* margin-left: 20px; */
  /* margin-bottom: 20px; */
  border: 1px solid #17366c;
  background: linear-gradient(to left, #3897cf, #3897cf) left top no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) left top no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right top no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) right top no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) left bottom no-repeat,
    linear-gradient(to bottom, #3897cf, #3897cf) left bottom no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat,
    linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  background-color: rgba(14, 8, 97, 0.418);
}
.el-table th {
  color: #ffffff; /* 字体颜色 */
  font-size: 16px;
  background-color: transparent !important; /* 背景透明 */
  border: 0;
  height: 30px;
  line-height: 30px;
}
.el-table tr,
.el-table td {
  color: #e5dada;
  font-size: 12px;
  background-color: transparent !important; /* 背景透明 */
  border: 0;
  height: 30px;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/test.vue